import React from 'react';
import { EditorState } from 'draft-js';
import { convertFromHTML, convertToHTML } from 'draft-convert';
import Fonts from 'app/utils/Fonts';

const CUSTOM_STYLE_PREFIX_COLOR = 'COLOR_';
const CUSTOM_STYLE_PREFIX_FBG_COLOR = 'FBG_COLOR_';
const CUSTOM_STYLE_PREFIX_FONTSIZE = 'FONTSIZE_';
const CUSTOM_STYLE_PREFIX_FONTFAMILY = 'FONTFAMILY_';

const contentStateFromHtml = html => convertFromHTML({
	htmlToStyle: (nodeName, node, currentStyle) => {
		if(node.style == null) {
			return currentStyle;
		}
		
		if (typeof(node.style.color) === 'string' && node.style.color.length > 0) {
			return currentStyle.add(CUSTOM_STYLE_PREFIX_COLOR + node.style.color);
		}
		if (typeof(node.style.backgroundColor) === 'string' && node.style.backgroundColor.length > 0) {
			return currentStyle.add(CUSTOM_STYLE_PREFIX_FBG_COLOR + node.style.backgroundColor);
		}
        if (typeof(node.style.fontSize) === 'string' && node.style.fontSize.length > 0) {
			return currentStyle.add(CUSTOM_STYLE_PREFIX_FONTSIZE + node.style.fontSize.slice(0, -2));
		}
       
        if (typeof(node.style.fontFamily) === 'string' && node.style.fontFamily.length > 0) {
            const ff = node.style.fontFamily.replace(/\\/g, "").replace(/['"]+/g, '');
            const style = Object.keys(Fonts).find(font => Fonts[font].fontFamily.replace(/['"]+/g, '') === ff);
			return currentStyle.add(style);
		}

		return currentStyle;
	},
    htmlToBlock: (nodeName, node) => {
        if (typeof(node.style.textAlign) === 'string' && node.style.textAlign.length > 0) {
            return { type: node.style.textAlign };
		}
    },
	htmlToEntity: (nodeName, node, createEntity) => {
        if (nodeName === 'a') {
            return createEntity(
                'LINK',
                'MUTABLE',
                {url: node.href}
            )
        }
    },
})(html);

export const editorStateFromHtml = html => EditorState.createWithContent(contentStateFromHtml(html));

export const htmlFromEditorState = editorState => convertToHTML({
	styleToHTML: (style) => {

        // Start with quantitative styles
		console.log(style)

		if (style.startsWith(CUSTOM_STYLE_PREFIX_COLOR)) {
			const cssDecl = {
				color: style.split(CUSTOM_STYLE_PREFIX_COLOR)[1]
			};
			return <span style={cssDecl} />;
		}

		if (style.startsWith(CUSTOM_STYLE_PREFIX_FBG_COLOR)) {
			const cssDecl = {
				backgroundColor: style.split(CUSTOM_STYLE_PREFIX_FBG_COLOR)[1]
			};
			return <span style={cssDecl} />;
		}

        if (style.startsWith(CUSTOM_STYLE_PREFIX_FONTSIZE)) {
			const cssDecl = {
				fontSize: style.split(CUSTOM_STYLE_PREFIX_FONTSIZE)[1] + 'px'
			};
			return <span style={cssDecl} />;
		}

        if (style.startsWith(CUSTOM_STYLE_PREFIX_FONTFAMILY)) {
			return <span style={{ fontFamily: Fonts[style].fontFamily}} />;
		}

		if (style === ('STRIKETHROUGH')) {
			
			return <span style={{ textDecoration: 'line-through'}} />;
		}
	},
    blockToHTML: (block) => {
		console.log(block);
		//block.text = escapeSpaces(block.text)
        switch (block.type) {
            case 'left': return <p style={{ textAlign: 'left'}} />;
            case 'center': return <p style={{ textAlign: 'center'}} />;
            case 'right': return <p style={{ textAlign: 'right'}} />;
            case 'justify': return <p style={{ textAlign: 'justify'}} />;
			case 'unstyled': 
				if (!block.text) return <p><br /></p>;
				return <p/>; 
        }
    },
	entityToHTML: (entity, originalText) => {
		if (entity.type === 'LINK') {
		  return <a href={entity.data.url}>{originalText}</a>;
		}
		return originalText;
	}
})(editorState.getCurrentContent());

function escapeSpaces (str) {
    return str.replace(/^ +/mg, function (match) {
        return match.replace(/ /g, '/\s');
    });
}
